import { Link } from "react-router-dom";
import { theme } from "@/lib/theme";

const BG = theme.bg;
const DARK = theme.dark;
const RED = theme.red;

export function NavigationHeader() {
  return (
    <header className="relative z-10" style={{ background: BG }}>
      <nav
        aria-label="Main"
        className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-y-3 px-4 py-4 sm:px-6 sm:py-5"
      >
        <Link
          to="/"
          className="flex min-h-[44px] shrink-0 items-center rounded-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1F2A3A]"
        >
          <img
            src="/images/logo_motosportsoftware_horiz.webp"
            alt="Motosport Software"
            width={384}
            height={44}
            className="h-10 w-auto sm:h-11"
          />
        </Link>
        <div className="flex flex-wrap items-center justify-end gap-x-3 gap-y-2 sm:gap-x-5">
          <Link
            to="/company/purpose"
            className="inline-flex min-h-[44px] items-center rounded-full px-4 py-2.5 text-sm font-semibold transition hover:opacity-80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1F2A3A]"
            style={{ color: DARK }}
          >
            Company
          </Link>
          <Link
            to="/contact"
            className="inline-flex min-h-[44px] items-center rounded-full px-4 py-2.5 text-sm font-semibold transition hover:opacity-80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1F2A3A]"
            style={{ color: DARK }}
          >
            Contact
          </Link>
          <Link
            to="/request-demo"
            className="inline-flex min-h-[44px] items-center rounded-full px-5 py-2.5 text-sm font-semibold text-white transition hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
            style={{ background: RED }}
          >
            Request a Demo
          </Link>
        </div>
      </nav>
    </header>
  );
}
